import { render, staticRenderFns } from "./MappedColumnMapping.vue?vue&type=template&id=61329557&"
import script from "./MappedColumnMapping.vue?vue&type=script&lang=js&"
export * from "./MappedColumnMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports